<!-- @format -->

<fieldset (window:resize)="updateVisibleItems()">
  <legend>
    <label data-cy="combobox-label" for="{{ id + '-combobox-input' }}" [id]="'combobox-label-' + id">{{ label }}</label>
  </legend>
  <div tabindex="0" class="combobox" [id]="id" [class.focused]="onFocus" #comboboxElement>
    @if (selected.length) {
      <div class="selected-items" #selectedItemsElement [ngClass]="{ 'cut-text': visibleSelectedItems.length === 1 && !onFocus }">
        @for (item of visibleSelectedItems; track item) {
          <button
            role="menuitem"
            data-cy="combobox-selected-option"
            type="button"
            [id]="item.value"
            [attr.aria-label]="('ARIA_LABEL.DELETE' | translate) + ' ' + item.label"
            (click)="removeSelected($event, item)"
            class="non-button selected-item">
            <sis-icon [iconClass]="'selected-item-icon'" icon="close"></sis-icon>
            {{ item.label }}
            @if (item.secondaryLabel) {
              <span class="secondary-label">{{ item.secondaryLabel }}</span>
            }
          </button>
        }
        @if (hiddenItemCount) {
          <span class="selected-item">+ {{ hiddenItemCount }}</span>
        }
      </div>
    }
    <input
      #inputElement
      data-cy="combobox-input"
      [class.hidden]="!onFocus && (visibleSelectedItems.length > 0 || hiddenItemCount !== 0)"
      class="combobox-input"
      type="text"
      [id]="id + '-combobox-input'"
      [placeholder]="placeholder"
      [attr.aria-describedby]="(id ? id + '-no-results' : '') + ' ' + (id ? id + '-guidance' : '')"
      [value]="searchTerm"
      (keyup)="search($event)" />
    <div class="combobox-buttons" #controlsElement>
      <button
        [class.hidden]="selected.length === 0"
        class="link-button"
        data-cy="combobox-clear-button"
        type="button"
        #deleteButtonElement
        (click)="clearAll()"
        [attr.aria-label]="'SIS_COMPONENTS.SELECT.CLEAR_FIELD' | translate">
        <sis-icon icon="close"></sis-icon>
      </button>
      @if (predictive) {
        <span #searchIconElement>
          <sis-icon icon="search"></sis-icon>
        </span>
      }
      @if (!predictive) {
        <button
          class="link-button"
          data-cy="combobox-toggle-button"
          type="button"
          tabindex="-1"
          #menuButtonElement
          (mouseup)="toggleMenu()"
          [attr.aria-label]="this.showDropdown ? ('ARIA_LABEL.CLOSE' | translate) : ('ARIA_LABEL.EXPAND' | translate)">
          <sis-icon icon="chevron" [iconClass]="showDropdown && onFocus ? 'ccw-90' : 'cw-90'"></sis-icon>
        </button>
      }
    </div>
    @if (showDropdown && onFocus && (!predictive || (predictive && nonGroupedOptions.length > 0) || hasGroupedOptions())) {
      <div class="dropdown" #dropdownElement data-cy="combobox-menu" role="list" [id]="'combobox-menu-' + id">
        @for (option of nonGroupedOptions; track option) {
          <sis-checkbox
            data-cy="combobox-option"
            [attr.id]="'sis-combobox-' + id + '-option-' + option.indexId"
            [ariaRole]="'option'"
            [name]="option.label"
            [label]="option.label"
            [secondaryLabel]="option.secondaryLabel"
            [title]="option.secondaryLabel ? option.label + ' ' + option.secondaryLabel : option.label"
            [checked]="isChecked(option)"
            (checkedChange)="select(option)"
            (keydown)="handleMenuKeyDown($event, option.indexId)"></sis-checkbox>
        }
        @for (header of headersToLoop(); track header; let last = $last; let i = $index) {
          <div [attr.aria-labelledby]="'sis-combobox-' + id + '-header-' + i" [attr.role]="'group'">
            <div class="option-header" role="presentation" [attr.aria-hidden]="true" [attr.id]="'sis-combobox-' + id + '-header-' + i">
              {{ groupedOptions[header].headerLabel }}
            </div>
            @for (option of groupedOptions[header].options; track option; let i = $index) {
              <sis-checkbox
                data-cy="combobox-option"
                [attr.id]="'sis-combobox-' + id + '-option-' + option.indexId"
                [ariaRole]="'option'"
                [ariaPosinset]="i + 1"
                [ariaSetsize]="groupedOptions[header].options.length"
                [name]="option.label"
                [label]="option.label"
                [secondaryLabel]="option.secondaryLabel"
                [title]="option.label"
                [checked]="isChecked(option)"
                (checkedChange)="select(option)"
                (keydown)="handleMenuKeyDown($event, option.indexId)"></sis-checkbox>
            }
            @if (!last) {
              <hr />
            }
          </div>
        }
        @if (showNoResults()) {
          <span [id]="id + '-no-results'" disabled> {{ "SEARCH.FILTER_SELECTOR.NO_RESULTS" | translate }} </span>
        }
      </div>
    }
  </div>
  @if (helpBlock) {
    <p [id]="id + '-guidance'" class="help-block">{{ helpBlock | translate }}</p>
  }
</fieldset>
